import React from 'react';
import { Container, Typography, Paper, Box, Grid, Card, CardMedia, CardContent } from '@mui/material';
import rosana from '../assets/rosana.jpg';
import ivania from '../assets/ivania.jpg';

function Secretary() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
        Secretária
      </Typography>

      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ mb: 3, maxWidth: 345, mx: 'auto' }}>
            <CardMedia
              component="img"
              height="400"
              image={rosana}
              alt="Rosana - Secretária"
              sx={{
                objectFit: 'cover',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            />
            <CardContent sx={{ textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
              <Typography variant="h6" component="div">
                Rosana Gama
              </Typography>
              <Typography variant="subtitle1">
                Secretária
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ mb: 3, maxWidth: 345, mx: 'auto' }}>
            <CardMedia
              component="img"
              height="400"
              image={ivania}
              alt="Eliane - Secretária"
              sx={{
                objectFit: 'cover',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
              }}
            />
            <CardContent sx={{ textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
              <Typography variant="h6" component="div">
                Ivania Duarte
              </Typography>
              <Typography variant="subtitle1">
                Secretária
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom color="primary">
              Horário de Atendimento
            </Typography>
            <Typography paragraph>
              Segunda a Sexta: 07:00 às 17:00
            </Typography>

            <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 3 }}>
              Serviços
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">Matrículas e Rematrículas</Typography>
              <Typography component="li">Emissão de Declarações</Typography>
              <Typography component="li">Histórico Escolar</Typography>
              <Typography component="li">Boletins</Typography>
              <Typography component="li">Transferências</Typography>
              <Typography component="li">Documentação em Geral</Typography>
            </Box>

            <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 3 }}>
              Documentos Necessários para Matrícula
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">RG e CPF do aluno (cópia)</Typography>
              <Typography component="li">RG e CPF dos pais ou responsáveis (cópia)</Typography>
              <Typography component="li">Comprovante de residência atualizado (cópia)</Typography>
              <Typography component="li">Histórico Escolar original ou Declaração da escola de origem</Typography>
              <Typography component="li">2 fotos 3x4 recentes</Typography>
              <Typography component="li">Cartão de vacina atualizado (cópia)</Typography>
              <Typography component="li">Cartão do SUS (cópia)</Typography>
            </Box>

            <Typography variant="h6" gutterBottom color="primary" sx={{ mt: 3 }}>
              Contato
            </Typography>
            <Typography paragraph>
              Para mais informações, entre em contato através do telefone da secretaria ou visite-nos pessoalmente.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Secretary;
